import React from 'react';
import { ElationLogoSVG } from './ElationLogoSVG';
import styles from './ElationLogoFull.less';

export const ElationLogoFull = (): JSX.Element => {
  return (
    <li className={styles.li}>
      <a href="/patients" className={styles.a}>
        <ElationLogoSVG className={styles.svg} />
      </a>
    </li>
  );
};
